import Link from 'next/link';

const MenuItemBlockHelp = ({ title, text, links }) => {
  return (
    <div className="bg-brand-50 rounded-lg p-4">
      <div className="txt-md mb-2 font-medium">{title}</div>
      <div className="txt-md text-grey-700 mb-6">{text}</div>
      <div className="flex flex-col gap-1">
        {links.map((link) => (
          <Link
            key={link.id}
            href={link.link || '/'}
            target={`${link.link || ''}`.startsWith('http') ? '_blank' : '_self'}
            rel={`${link.link || ''}`.startsWith('http') ? 'noopener noreferrer' : undefined}
            className="text-brand-400 underline"
          >
            {link.label}
          </Link>
        ))}
      </div>
    </div>
  );
};
export default MenuItemBlockHelp;
